import PropTypes from 'prop-types';
import { useState } from 'react';
import html2pdf from 'html2pdf.js';
import Background from '../../../assets/participation-certificate/background.jpeg';
import Signature from '../../../assets/participation-certificate/signature.png';
import Firma from '../../../assets/participation-certificate/firma.png';

const formatParticipation = (value) => {
  if (!value) return '';
  const lower = value.toLowerCase();
  if (lower === 'oral') return 'Oral';
  if (lower === 'poster') return 'Poster';
  if (lower === 'attendee') return 'Attendance';
  return value;
};

const sanitizeFilename = (value) =>
  (value || 'certificate')
    .toString()
    .normalize('NFD')
    .replace(/[̀-ͯ]/g, '')
    .replace(/[^a-zA-Z0-9-_ ]/g, '')
    .trim()
    .replace(/\s+/g, '_')
    .slice(0, 80) || 'certificate';

export const AcceptanceLetterComponent = ({ abstract }) => {
  const [isGenerating, setIsGenerating] = useState(false);

  const DownloadPdf = async () => {
    const element = document.getElementById('printablediv');
    if (!element || isGenerating) return;

    setIsGenerating(true);
    try {
      const filename = `SNN2026_Certificate_${sanitizeFilename(abstract.code || abstract.title)}.pdf`;
      await html2pdf()
        .from(element)
        .set({
          margin: 0,
          filename,
          image: { type: 'jpeg', quality: 0.98 },
          html2canvas: {
            scale: 2,
            useCORS: true,
            backgroundColor: '#ffffff',
            windowWidth: element.scrollWidth,
            windowHeight: element.scrollHeight,
          },
          jsPDF: { unit: 'in', format: [11, 8.5], orientation: 'landscape' },
        })
        .save();
    } catch (error) {
      alert('Error al generar el PDF. Intenta nuevamente.');
    } finally {
      setIsGenerating(false);
    }
  };

  const participationLabel = formatParticipation(
    abstract.participation || abstract.accepted,
  );

  const authorsLine = (abstract.authors || [])
    .map((author) => `${author.name} ${author.lastName}`)
    .join(', ');

  return (
    <>
      <button className="print-button" onClick={DownloadPdf} disabled={isGenerating}>
        <span className="material-symbols-outlined">download</span>
        {isGenerating ? 'Generating PDF…' : 'Download PDF'}
      </button>
      <div id="printablediv">
        <div className="participation-cert-page">
          <img src={Background} className="participation-cert-bg" alt="" />
          <div className="participation-cert-content">
            <h1 className="participation-cert-title">
              The Organizing Committee of SNN 2026 certifies that:
            </h1>
            <p className="participation-cert-author">{authorsLine}</p>
            <p className="participation-cert-subtitle">
              Presented the following{' '}
              <span className="participation-cert-type">{participationLabel}</span>{' '}
              contribution:
            </p>
            <p className="participation-cert-paper">
              {abstract.code && abstract.code !== 'undefined' ? (
                <>
                  <span className="participation-cert-code">{abstract.code}</span>
                  <span className="participation-cert-sep">: </span>
                </>
              ) : null}
              <span className="participation-cert-paper-title">{abstract.title}</span>
            </p>
          </div>
          <div className="participation-cert-footer">
              <img
                  src={Firma}
                  className="participation-cert-signature"
                  alt="Signature"
              />
            <img
              src={Signature}
              className="participation-cert-signature"
              alt="Signature"
            />
            <div className="participation-cert-signature-line">
              ________________________________
            </div>
            <p className="participation-cert-chair">Dr. Uriel Caudillo Flores</p>
            <p className="participation-cert-chair-role">SNN 2026 Chairman</p>
            <p className="participation-cert-chair-date">
              May 11 to 15, 2026 // Ensenada, B. C. Mexico
            </p>
          </div>
        </div>
      </div>
    </>
  );
};

AcceptanceLetterComponent.propTypes = {
  abstract: PropTypes.any.isRequired,
};
